export default "__VITE_ASSET__9c43ddd2__"